import {EntityService} from "@/model/service/entity-service"
import {Office} from "@/model/entity/office/office"
import {AxiosPromise} from "axios"

class OfficeService extends EntityService<Office> {
  constructor() {
    super("office", Office)
  }

  getOfficeByCompany(companyId: number): AxiosPromise<Office[]> {
    return this.$http.get(this.path + "/by_company/" + companyId)
  }

}

export interface IOfficeService extends EntityService<Office> {
  getOfficeByCompany(companyId: number): AxiosPromise<Office[]>
}

const service = new OfficeService()

export const officeService = service
